/// <reference path="../../../node_modules/@types/uuid/index.d.ts" />

const uuid = require('uuid/v4');

interface IWrapHeader {
    ID: string;
    Application: string;
    Company: string;
    Channel: string;
    Bank: string;
}
interface IWrap<T> {
    header: IWrapHeader;
    payload: T;
}

export class MetaData {
    get = (name: string): string => {
        if (this[name] == null) {
            this[name] = $("meta[name='" + name + "']").attr("content");
        }
        return this[name];
    };

    removeSlash = function (path: string) {
        if (path && path.length > 0) {
            return (path.charAt(0) == '/') ? path.slice(1) : path;
        }
        return '';
    }

    getContextPath = (path: string) => {
        return this.get("contextPath") + this.removeSlash(path);
    }

    wrap2Request = (payload: any) => {
        var uuidStr = uuid();
        payload = payload || {};
        //payload.userId = this.get('userId');
        return {
            header: <IWrapHeader>{
                ID: uuidStr,
                Application: this.get('appId'),
                Company: this.get('company'),
                Bank: 'NBG',
                Channel: this.get('channel')
            },
            payload: payload
        };
    }
}

interface IParamsBuilder {
    params: string[];
    addParams: (name: string, values: any) => IParamsBuilder;
    build: () => string;
}

class ParamsBuilder implements IParamsBuilder {
    params: string[];
    constructor() {
        this.params = [];
    }

    addParams = function (name: string, values: any): IParamsBuilder {
        if (values) {
            if (!Array.isArray(values)) {
                values = [values];
            }
            for (var i = 0; i < values.length; i++) {
                this.params.push(name + "=" + encodeURIComponent(values[i]));
            }
        }
        return this;
    };

    build = function () {
        return this.params.join("&");
    };
}

/**
* A helper to construct URLs, possibly with query parameters.
*
* Initialize either using the constructor `new UrlBuilder()` or using the `local()`
* factory `UrlBuilder.ctxRel()`. The `ctxRel()` factory will construct URLs relative
* to the context path (using the `ctxPath` service). Both the constructor and the
* factory take an optional initial path argument, e.g. `new UrlBuilder("api/foo")`.
*
* Append path elements using the `appendPath()` method. It will correctly append
* slashes. This method takes varargs, i.e. `appendPath("foo","bar")` works as expected.
*
* Add query parameters using `addParams()`. It uses the `ParamsBuilder` service.
* Calls to `appendPath()` and `addParams()` can be interleaved.
*
* Retrieve the URL string using `toUrl()`.
*
* The static utility method `UrlBuilder.addParams(pathNow, path)` appends `path`
* to `pathNow` and returns the new value.
*
* Example:
* var url = new UrlBuilder("/myapplication/api").appendPath("foo").addParams("search","bar").toUrl();
* --> "/myapplication/api/foo?search=bar
* var url = UrlBuilder.ctxRel("api").appendPath("foo").addParams("search","bar").toUrl();
* --> same as above for contextPath=/myapplication
*/

interface IUrlBuilder {
    addParams: (name: string, values: any) => IUrlBuilder;
    toUrl: () => string;
}

export class UrlBuilder implements IUrlBuilder {
    private path: string;
    private ParamsBuilder: IParamsBuilder;

    constructor(path: string) {
        this.path = path || "";
    }

    addParams = function (name: string, values: string | string[]): UrlBuilder {
        this.params = this.params || new ParamsBuilder();
        this.params.addParams(name, values);
        return this;
    }

    toUrl = function (): string {
        var querystr: string = null,
            ret: string = this.path;
        if (this.params != null)
            querystr = this.params.build();
        if (querystr != null && querystr.length > 0)
            ret += "?" + querystr;
        return ret;
    }
}